/* eslint-disable no-unused-vars */
import React from "react";
import { HorseIcon, CattleIcon } from "../../lib/icons";

function getFarmEmojiConfig(value, emojiType = "") {
  const type = String(emojiType || "").trim();
  if (type === "horse") return { value: value || "🐴", emojiType: "horse", title: "Cavalo da fazenda" };
  if (type === "cattle") return { value: value || "🐮", emojiType: "cattle", title: "Rebanho da fazenda" };
  return { value: value || "🌾", emojiType: "", title: "Emoji da fazenda" };
}


function FarmEmoji({ farm, value, emojiType = "", size = 20 }) {
  const conf = getFarmEmojiConfig(value ?? farm?.emoji, emojiType || farm?.emojiType || "");
  if (conf.emojiType === "horse") return <HorseIcon size={size} title={conf.title} />;
  if (conf.emojiType === "cattle") return <CattleIcon size={Math.round(size * 1.2)} title={conf.title} />;
  return <span style={{ fontSize: size, lineHeight: 1, display: "inline-flex", alignItems: "center", justifyContent: "center" }}>{conf.value}</span>;
}

function FarmInlineLabel({ farm, value, emojiType = "", name = "", size = 16, gap = 6, textStyle = {} }) {
  const resolvedName = String(name || farm?.name || "").trim();
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap, minWidth: 0 }}>
      <FarmEmoji farm={farm} value={value} emojiType={emojiType} size={size} />
      {resolvedName ? <span style={textStyle}>{resolvedName}</span> : null}
    </span>
  );
}

export { getFarmEmojiConfig, FarmEmoji, FarmInlineLabel };
